import CarCoverageSummary from './CarCoverageSummary'

export default CarCoverageSummary
